import t from "./highrise1522.mjs";
var o = t(Object.getPrototypeOf, Object);
export {
  o as default
};
